import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=50f2abc5&scoped=true&component=true&componentId=index4cd5f06a"
import script from "./index.mpx?vue&type=script&lang=js&component=true&componentId=index4cd5f06a"
export * from "./index.mpx?vue&type=script&lang=js&component=true&componentId=index4cd5f06a"
import style0 from "./index.mpx?vue&type=style&index=0&id=50f2abc5&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m4cd5f06a%22%7D&component=true&componentId=index4cd5f06a"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f2abc5",
  null
  
)

export default component.exports